import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Row, Col, Button, Icon } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import drivesvg from '../automobile-drive-svgrepo-com.svg';

import ReactGoogleMapLoader from "react-google-maps-loader"
import ReactGooglePlacesSuggest from "react-google-places-suggest"

import { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}

const API_KEY = "AIzaSyCZ-lrgcyu8rNUArDpZuWSEPVoLBBNt2zE"
class Home extends Component {
  state = {
    fromSearch: "",
    fromValue: "",
    toSearch: "",
    toValue: ""
  }

  handleFromInputChange(e) {
    this.setState({fromSearch: e.target.value, fromValue: e.target.value})
  }

  handleFromSelectSuggest(suggest) {
    console.log(suggest)
    this.setState({fromSearch: "", fromValue: suggest.formatted_address})
  }

  handleToInputChange(e) {
    this.setState({toSearch: e.target.value, toValue: e.target.value})
  }

  handleToSelectSuggest(suggest) {
    console.log(suggest)
    this.setState({toSearch: "", toValue: suggest.formatted_address})
  }

  onChange(date, dateString) {
    console.log(date, dateString);
  }
  

  render() {
    const {fromSearch, fromValue, toSearch, toValue} = this.state
    return (
<div>
  <Desktop>
       <div style={{ background: '#bae7ff', padding: 50, minHeight: 280 }}>
      <Row>
        <Col md={16} sm={24}>
        <Row>
          <Col md={22} sm={24}>
          <span style={{color: '#002766', fontSize: '5vw', fontWeight: 'bolder'}}>Share rides across districts in Uganda.</span>
          </Col>
          <Col span={24}>
          <span style={{color: '#00474f', fontSize: '2vw'}}>
            Trust Villaride to share rides as you travel within Uganda
          </span>
          <br/>
          <br/>
          <Col md={24} sm={24} xs={24}>
               <Button.Group size="large">
                 
                    <Button type="primary" style={{backgroundColor: '#ff3d00', borderRightColor: '#ffffff', borderLeftColor: '#ff3d00', borderTopColor: '#ff3d00', borderBottomColor: '#ff3d00'}}>
                      <Link to="/find-ride">
                          <Icon type="search" /> Find a Trip
                      </Link>
                    </Button>
                 
                
                <Button type="primary" style={{backgroundColor: '#002766', borderLeftColor: '#ffffff', borderRightColor: '#002766', borderTopColor: '#002766', borderBottomColor: '#002766' }}>
                  <Link to="/post-trip">
                    <Icon type="plus" /> Post a Trip
                  </Link>
                </Button>
            </Button.Group>
            </Col> 
          </Col>
        </Row>
        <br/>
        <br/>
        </Col>
        <Col md={8} sm={24}>
        <img src={drivesvg} className="App-logo" alt="logo" />
        </Col>
      </Row>
      </div>  
      </Desktop> 

      <Tablet>
       <div style={{ background: '#bae7ff', padding: 50, minHeight: 280 }}>
      <Row>
        <Col md={16} sm={24}>
        <Row>
          <Col md={22} sm={24}>
          <span style={{color: '#002766', fontSize: '2em', fontWeight: 'bolder'}}>Share rides across districts in Uganda.</span>
          </Col>
          <Col span={24}>
          <span style={{color: '#00474f', fontSize: '1em'}}>
            Trust Villaride to share rides as you travel within Uganda
          </span>
          <br/>
          <br/>
          <Col md={24} sm={24} xs={24}>
               <Button.Group size="large">
                 
                    <Button type="primary" style={{backgroundColor: '#ff3d00', borderRightColor: '#ffffff', borderLeftColor: '#ff3d00', borderTopColor: '#ff3d00', borderBottomColor: '#ff3d00'}}>
                      <Link to="/find-ride">
                          <Icon type="search" /> Find a Trip
                      </Link>
                    </Button>
                 
                
                <Button type="primary" style={{backgroundColor: '#002766', borderLeftColor: '#ffffff', borderRightColor: '#002766', borderTopColor: '#002766', borderBottomColor: '#002766' }}>
                  <Link to="/post-trip">
                    <Icon type="plus" /> Post a Trip
                  </Link>
                </Button>
            </Button.Group>
            </Col> 
          </Col>
        </Row>
        <br/>
        <br/>
        </Col>
        <Col md={8} sm={24}>
        <img src={drivesvg} className="App-logo" alt="logo" />
        </Col>
      </Row>
      </div>  
      </Tablet>  

      

      <Mobile>
       <div style={{ background: '#bae7ff', padding: 20, minHeight: 280 }}>
      <Row>
        <Col md={16} sm={24}>
        <Row>
          <Col md={22} sm={24}>
          <span style={{color: '#002766', fontSize: '2em', fontWeight: 'bolder'}}>Share rides across districts in Uganda.</span>
          </Col>
          <Col span={24}>
          <span style={{color: '#00474f', fontSize: '1em'}}>
            Trust Villaride to share rides as you travel within Uganda
          </span>
          <br/>
          <br/>
          <Col md={24} sm={24} xs={24}>
               <Button.Group size="large">
                 
                    <Button type="primary" style={{backgroundColor: '#ff3d00', borderRightColor: '#ffffff', borderLeftColor: '#ff3d00', borderTopColor: '#ff3d00', borderBottomColor: '#ff3d00'}}>
                      <Link to="/find-ride">
                          <Icon type="search" /> Find a Trip
                      </Link>
                    </Button>
                 
                
                <Button type="primary" style={{backgroundColor: '#002766', borderLeftColor: '#ffffff', borderRightColor: '#002766', borderTopColor: '#002766', borderBottomColor: '#002766' }}>
                  <Link to="/post-trip">
                    <Icon type="plus" /> Post a Trip
                  </Link>
                </Button>
            </Button.Group>
            </Col> 
          </Col>
        </Row>
        <br/>
        <br/>
        </Col>
        <Col md={8} sm={24}>
        <img src={drivesvg} className="App-logo" alt="logo" />
        </Col>
      </Row>
      </div>  
      </Mobile>  
    </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null
  }
}

export default connect(mapStateToProps, null)(Home);
// export default Home;

